// 2026-10-28：绑定提醒按端、机构和账号持久记忆，不随登录令牌或刷新清零。
export const BINDING_DAY=24*60*60*1000
export type ReminderStorage=Pick<Storage,'getItem'|'setItem'|'removeItem'>
export function bindingReminderKey(channel:string,id:number,orgId:number){return id>0&&orgId>=1000?'wechat-bind-reminder:v2:'+JSON.stringify([channel,id,orgId]):''}
export function readBindingReminder(storage:ReminderStorage,key:string,now=Date.now()){
 try{const v=JSON.parse(storage.getItem(key)||'{}');return {until:Number.isFinite(v.until)&&v.until>0&&v.until<=now+7*BINDING_DAY?v.until:0,skips:Number.isInteger(v.skips)&&v.skips>0?Math.min(v.skips,3):0}}catch{return {until:0,skips:0}}
}
export function postponeBindingReminder(storage:ReminderStorage,key:string,now=Date.now(),skip=true){
 const old=readBindingReminder(storage,key,now),skips=skip?Math.min(old.skips+1,3):old.skips
 const record={until:now+(skips>=3?7:1)*BINDING_DAY,skips}
 if(key)try{storage.setItem(key,JSON.stringify(record))}catch{/* 存储不可用时由组件内存继续抑制。 */}
 return record
}
export function clearBindingReminder(storage:ReminderStorage,key:string){if(key)try{storage.removeItem(key)}catch{/* 不影响登录和绑定。 */}}
